export default __webpack_public_path__ + "static/media/384.4e18ad84.jpg";